// C11 · البوليصة والعقد (policy & contract — read only) i18n namespace.
// Full ar/en parity for every key the policy-contract.vue view binds. Merged
// into the shared messages by i18n.ts's require.context over ./screens/*.js.
module.exports = {
  ar: {
    'policy-contract': {
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل البوليصة والعقد',
      title: 'البوليصة والعقد',
      policiesPanel: 'بوالص الشركة',
      policiesCount: '{n} بوالص',
      noPolicies: 'لا توجد بوالص لهذه الشركة',
      pickHint: 'اختر بوليصة لعرض شروطها. لكل بوليصة رقمها وفترة سريانها وسقفها وعقدها.',
      conditions: 'شروط البوليصة',
      readOnly: 'عرض فقط',
      number: 'رقم البوليصة',
      klass: 'الفئة / الفرع',
      validity: 'السريان',
      annualCap: 'السقف السنوي / فرد',
      deductible: 'نسبة التحمّل',
      statusLabel: 'حالة البوليصة',
      statusActive: 'سارية',
      statusExpiring: 'قرب الانتهاء',
      statusExpired: 'منتهية',
      statusUnknown: 'غير معروفة',
      contract: 'العقد الموقّع',
      signedShort: 'موقّع',
      signedAt: 'تاريخ التوقيع',
      broker: 'وسيط التأمين',
      preview: 'معاينة',
      download: 'تنزيل PDF',
      fileUnavailable: 'الملف الأصلي للعقد غير متاح للمعاينة أو التنزيل حاليًا',
      noContract: 'لا يوجد عقد مرفوع',
      coverages: 'التغطيات',
      coveragesUnavailable: 'أسماء التغطيات غير متاحة حاليًا',
      noCoverages: 'لا توجد تغطيات محددة لهذه البوليصة',
      exclusions: 'الاستثناءات',
      noExclusions: 'لا توجد استثناءات على هذه البوليصة',
      noteTitle: 'ملاحظة',
      exclusionsNote: 'يتم التحقق من هذه الاستثناءات تلقائيًا أثناء مراجعة المطالبة لدى الأدمن. هذه الشاشة للعرض فقط — يتم التعديل من لوحة تحكم الأدمن.',
      kinds: {
        sub_entity: 'فرع تأميني',
        category: 'فئة',
        group: 'مجموعة',
      },
      periods: {
        annual: 'سنويًا',
        per_visit: 'لكل زيارة',
        lifetime: 'مدى الحياة',
        monthly: 'شهريًا',
      },
    },
  },
  en: {
    'policy-contract': {
      loading: 'Loading…',
      error: 'Something went wrong while loading the policy & contract',
      title: 'Policy & Contract',
      policiesPanel: 'Company policies',
      policiesCount: '{n} policies',
      noPolicies: 'No policies for this company',
      pickHint: 'Pick a policy to view its terms. Each policy has its number, validity, cap and contract.',
      conditions: 'Policy terms',
      readOnly: 'read-only',
      number: 'Policy no.',
      klass: 'Class / branch',
      validity: 'Validity',
      annualCap: 'Annual cap / person',
      deductible: 'Deductible',
      statusLabel: 'Policy status',
      statusActive: 'Active',
      statusExpiring: 'Expiring soon',
      statusExpired: 'Expired',
      statusUnknown: 'Unknown',
      contract: 'Signed contract',
      signedShort: 'Signed',
      signedAt: 'Signed on',
      broker: 'Insurance broker',
      preview: 'Preview',
      download: 'Download PDF',
      fileUnavailable: 'The contract\'s source file is not available for preview or download right now',
      noContract: 'No contract uploaded',
      coverages: 'Coverages',
      coveragesUnavailable: 'Coverage names are not available right now',
      noCoverages: 'No coverages listed for this policy',
      exclusions: 'Exclusions',
      noExclusions: 'No exclusions on this policy',
      noteTitle: 'Note',
      exclusionsNote: 'These exclusions are checked automatically during claim review by the admin. The whole screen is read-only — editing happens in the admin dashboard.',
      kinds: {
        sub_entity: 'Sub-entity',
        category: 'Category',
        group: 'Group',
      },
      periods: {
        annual: 'Annual',
        per_visit: 'Per visit',
        lifetime: 'Lifetime',
        monthly: 'Monthly',
      },
    },
  },
};
